import { render, staticRenderFns } from "./propertyPictures.vue?vue&type=template&id=4473e8b5"
import script from "./propertyPictures.vue?vue&type=script&lang=js"
export * from "./propertyPictures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports